module.exports = __webpack_public_path__ + "img/hum_pack.2a934837.png";